import axios from 'axios';
import {
    REMOVE_USER_ROOM,
    REMOVE_USER_ROOMMATE,
    SELECT_ROOM,
    SET_ROOM_INFO,
    SET_USER_ROOM,
    SET_OPEN,
} from '../constants/mutations';

const state = {
    activeRoom: null,
    open: false,
    activeRoomInfo: null,
};

const getters = {
    activeRoom: (state) => state.activeRoom,
    open: (state) => state.open,
    activeRoomInfo: (state) => state.activeRoomInfo,
};

const actions = {
    async getRoomInfo({ commit, dispatch }, activeRoom) {
        axios
            .get(`/api/rooms/${activeRoom}`)
            .then((res) => {
                commit(SET_ROOM_INFO, res.data);
            })
            .catch((err) => {
                commit(SET_ROOM_INFO, null);
                dispatch(
                    `Notification/notify`,
                    { message: err.response.data.message, color: 'error' },
                    { root: true }
                );
            });
    },
    selectRoom({ dispatch, commit }, activeRoom) {
        if (activeRoom) {
            dispatch('getRoomInfo', activeRoom);
            commit(SELECT_ROOM, activeRoom);
            dispatch('Room/switchFloor', activeRoom.substring(0, 1), { root: true });
        }
        commit(SET_OPEN, !!activeRoom);
    },
    acceptRoom({ commit, dispatch, rootState }, reservationId) {
        axios
            .post(`/api/reservations/${reservationId}`)
            .then(() => {
                commit(
                    `User/${SET_USER_ROOM}`,
                    {
                        status: 'RESERVED',
                        roommateStatus: 'RESERVED',
                    },
                    { root: true }
                );
            })
            .catch((err) => {
                dispatch(
                    `Notification/notify`,
                    { message: err.response.data.message, color: 'error' },
                    { root: true }
                );
            })
            .finally(() => {
                dispatch('getRoomInfo', rootState['User/user.room_number'] );
            });
    },
    applyToRoom({ commit, dispatch }, room) {
        return axios
            .post('/api/reservations/apply', { room })
            .then(({ data }) => {
                commit(`User/${SET_USER_ROOM}`, { room, reservationId: data.id, status: 'APPLIED' }, { root: true });
            })
            .catch((err) => {
                dispatch(
                    `Notification/notify`,
                    { message: err.response.data.message, color: 'error' },
                    { root: true }
                );
            })
            .finally(() => {
                dispatch('getRoomInfo', room);
            });
    },
    cancelRoom({ commit, dispatch }) {
        return axios
            .delete('/api/reservations/cancel')
            .then(() => {
                commit(`User/${REMOVE_USER_ROOM}`, {}, { root: true });
                dispatch('selectRoom', null);
            })
            .catch((err) => {
                dispatch(
                    `Notification/notify`,
                    { message: err.response.data.message, color: 'error' },
                    { root: true }
                );
            });
    },
    inviteToRoom({ commit, dispatch }, { room, roommate }) {
        return axios
            .post('/api/reservations/invite', { room, roommate })
            .then(() => {
                commit(
                    `User/${SET_USER_ROOM}`,
                    { room, roommate, roommateStatus: 'INVITED' },
                    { root: true }
                );
            })
            .catch((err) => {
                dispatch(
                    `Notification/notify`,
                    { message: err.response.data.message, color: 'error' },
                    { root: true }
                );
            })
            .finally(() => {
                dispatch('getRoomInfo', room);
            });
    },
    declineRoom({ commit, dispatch }, reservationId) {
        return axios
            .delete(`/api/reservations/${reservationId}`)
            .then(() => {
                commit(`User/${REMOVE_USER_ROOM}`, {}, { root: true });
                dispatch('selectRoom', null);
            })
            .catch((err) => {
                dispatch(
                    `Notification/notify`,
                    { message: err.response.data.message, color: 'error' },
                    { root: true }
                );
            });
    },
    declineRoommate({ commit, dispatch }, reservationId) {
        return axios
            .delete(`/api/reservations/${reservationId}`)
            .then(() => {
                commit(`User/${REMOVE_USER_ROOMMATE}`, {}, { root: true });
            })
            .catch((err) => {
                dispatch(
                    `Notification/notify`,
                    { message: err.response.data.message, color: 'error' },
                    { root: true }
                );
            });
    },
    reserveRoom({ commit, rootState, dispatch }, { room, roommate }) {
        return axios
            .post('/api/reservations/reserve', {
                room,
                roommate,
            })
            .then(() => {
                commit(
                    `User/${SET_USER_ROOM}`,
                    {
                        room,
                        roommate,
                        status: 'INVITED',
                        reservationStatus: 'INVITED',
                        by: rootState.User.user.neptun,
                    },
                    { root: true }
                );
                return true;
            })
            .catch((err) => {
                dispatch(
                    `Notification/notify`,
                    { message: err.response.data.message, color: 'error' },
                    { root: true }
                );
                return false;
            })
            .finally(() => {
                dispatch('getRoomInfo', room);
            });
    },
};

const mutations = {
    [SELECT_ROOM](state, activeRoom) {
        state.activeRoom = activeRoom;
    },
    [SET_ROOM_INFO](state, roomInfo) {
        if (roomInfo) {
            state.activeRoomInfo = _.sortBy(roomInfo,'self').reverse()
        } else {
            state.activeRoomInfo = null;
        }
    },
    [SET_OPEN](state, open) {
        state.open = open;
    },
};

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations,
};
